// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__1buyM","tab":"styles_tab__1u90A"};